import { Carrier } from '@app/services/carriers/carrier.model';
import { carrierTypeToNameMap } from '@pdqdev/pdq-shared/dist/CarrierData';

export function isCarrierShippable(carrier: Carrier) {
  if (!carrier?.type) {
    return false;
  }

  return carrierTypeToNameMap[carrier.type.name];
}

export function displayProvidersData(carrier: Carrier): 'providers' | 'providerServices' {
  return 'providers';
}

export function isEditingDisabledCarrier(carrier: Carrier) {
  return !!carrier?.type?.custom_fields?.isCarrierEditingDisabledBySystem;
}

export function carrierSupportSchedulePickup(carrier: Carrier): boolean {
  return carrier?.type?.custom_fields?.supportsScheduledPickup;
}

export function carrierSupportsLiveETA(carrier: Carrier): boolean {
  return carrier?.type?.custom_fields?.supportsLiveETA ?? true;
}

export function isCarrierSupportsExternalAuth(carrier: Carrier): boolean {
  return ['UPS-Abstract'].includes(carrier?.type?.name);
}
